import * as React from "react";

/**
 * Handles keyboard events for elements that should behave like buttons.
 * Triggers a click event when Enter or Space is pressed.
 * Use this for accessible custom button-like elements (role="button").
 */
export const handleKeyboardClick = (e: React.KeyboardEvent) => {
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    (e.currentTarget as HTMLElement).click();
  }
};

/**
 * Creates a keyboard handler that calls the provided callback with an item name.
 * Useful for dropdown toggles and similar interactive elements.
 */
export const createDropdownKeyHandler = (
  itemName: string,
  onClick: (itemName: string) => void,
) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClick(itemName);
    }
  };
};
